import PubSub from "underpub-js";

var FloorplanCategoryHeader = function(options) {

	this.options = {
		$el: false,
		baseClass: 'mol-FloorplanCategoryHeader',
	};

	$.extend(true, this.options, options);

};

FloorplanCategoryHeader.prototype.init = function() {

	var self = this;

};

export default FloorplanCategoryHeader;
